import React from "react";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import vi from "date-fns/locale/vi";
import {registerLocale} from "react-datepicker";
import ModalCreateFoodType from "./modalCreateFoodType";
import BusTypeController from "../../../../services/system/bus/bus-type-controller";
import ModalEditFoodType from "./modalEditFoodType";
import FoodController from "../../../../services/system/food/food-controller";
import {getSchoolYear} from "../../../../utils/authority";
registerLocale("vi", vi);
class FoodTypeManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",

            state: "ACTIVE",
            listData: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên loại thực phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Chú thích",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListFoodCategory()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListFoodCategory();
            }
        );
    };
    getListFoodCategory() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            name: this.state.name,
            sort: "created_at desc"
        };
        FoodController.searchCategory(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListFoodCategory()
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Đang hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="food-type" parentClass="menu-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Loại thực phẩm"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mb-1">
                                                <label className="label-item col-md-4 col-5">Tên loại thực phẩm</label>
                                                <input
                                                    placeholder="Nhập tên loại thực phẩm"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.name}
                                                    maxLength={50}
                                                    onChange={val =>
                                                        this.setState({name: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <button
                                                style={{height: 35, marginRight: 12}}
                                                type="button"
                                                className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                onClick={() => {
                                                    this.onhandleSearch()
                                                }}
                                            >
                                                Tìm kiếm
                                            </button>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <button
                                                    style={{height: 35, marginRight: 12}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => {
                                                        this.setState({showModalCreate: true})
                                                    }}
                                                >
                                                    Thêm mới
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "left"
                                                 }}>
                                                <label className="label-item col-12"><b>Lưu ý:</b> Loại thực phẩm đã được áp dụng thì không xóa được</label>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListFoodCategory()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.des}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>

                                                                <button className="btn btn-action p-2"
                                                                        title='Sửa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            this.setState({itemSelected: row.id, showModalEdit: true})
                                                                        }}
                                                                >
                                                                    <i className="ti-pencil-alt"/>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalEditFoodType
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
                <ModalCreateFoodType
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default FoodTypeManagement;
